import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { PlacesType, Tooltip } from 'react-tooltip';

import classes from './TooltipIcon.module.scss';

interface TooltipIconProps {
  icon: ReactNode;
  tooltipText: string;
  tooltipId: string;
  tooltipPosition?: PlacesType;
  className?: string;
}

export const TooltipIcon: FC<TooltipIconProps> = ({
  icon,
  tooltipText,
  tooltipId,
  tooltipPosition = 'top',
  className,
}) => (
  <>
    <span data-tooltip-id={tooltipId} className={classes.icon}>
      {icon}
    </span>
    <Tooltip id={tooltipId} place={tooltipPosition} opacity={1} className={classNames(classes.tooltip, className)}>
      {tooltipText}
    </Tooltip>
  </>
);
